<template xmlns:style="http://www.w3.org/1999/xhtml">
  <div>
    <div
      v-if="
        $store.state.users.token === '' ||
          $store.state.invoiceSub.needInvoiceCourses === null ||
          !$store.state.invoiceSub.isInvoiceInfoLoaded
      "
    >
      <LoadingPage />
    </div>
    <div
      v-if="
        $store.state.users.token !== '' &&
          $store.state.invoiceSub.needInvoiceCourses !== null &&
          $store.state.invoiceSub.isInvoiceInfoLoaded
      "
    >
      <div
        v-if="!$store.state.invoiceSub.needInvoiceCourses.current_need_invoice"
      >
        <van-empty
          :image="img_empty"
          description="目前没有需要开票的课程，如需要开票，请修改报名信息，开启‘需要发票’选项，或与直接与老师联系。"
        />
      </div>
      <div
        v-if="$store.state.invoiceSub.needInvoiceCourses.current_need_invoice"
      >
        <van-notice-bar
          scrollable
          class="notice"
          left-icon="info-o"
          text="请仔细核对开票资料中的每一项后再提交，修改信息后将重新审核。"
        />
        <van-steps
          :active="getStatus()"
          active-icon="location"
          inactive-icon="arrow"
          style="margin:0 auto; margin-bottom: 20px;"
        >
          <van-step>填写开票信息</van-step>
          <van-step>审核中</van-step>
          <van-step>审核通过</van-step>
        </van-steps>

        <!--  message-->
        <div
          v-if="$store.state.invoiceSub.invoiceInfo.verify_notes !== null"
          class="message0"
        >
          <div><van-icon name="manager" /> <b>管理员留言：</b></div>
          <div style="padding-top: 5px">
            {{ $store.state.invoiceSub.invoiceInfo.verify_notes }}
          </div>
        </div>
        <!--  开票价格显示-->
        <div class="message0" style="background-color: aliceblue">
          <div>
            <van-icon name="bill" />
            <b>需要开票的课程及开票金额：</b>
          </div>
          <div>
            <b style="color: red"
              >注意：最终开票金额是您实际缴纳的费用，这里显示的金额可能会随着您优惠项目的通过而减少，仅供参考。</b
            >
          </div>
          <div
            v-for="(courseInfo, index) in $store.state.invoiceSub
              .needInvoiceCourses.course_infos"
            :key="index"
            style="margin: 10px auto;"
          >
            {{ courseInfo.package_name }}: ￥{{ courseInfo.face_value[0] }}
          </div>
        </div>
        <van-form @submit="onSubmit">
          <!--个人信息-->
          <div style="margin: 10px auto;">
            <van-cell-group>
              <van-field
                required
                name="radio"
                label="开票内容"
                :rules="[{ required: true, message: '请选择开票内容' }]"
              >
                <template #input>
                  <van-radio-group
                    v-model="$store.state.invoiceSub.invoiceInfo.content"
                  >
                    <van-radio
                      v-for="(content, content_index) in $store.state.invoiceSub
                        .needInvoiceCourses.invoice_content_list"
                      icon-size="15px"
                      :name="content.id"
                      :key="content_index"
                      v-show="
                        !content.admin_only ||
                          $store.state.invoiceSub.oldContent === content.id
                      "
                      >{{ content.name }}</van-radio
                    >
                  </van-radio-group>
                </template>
              </van-field>
              <van-field
                required
                name="radio"
                label="开票类型"
                :rules="[{ required: true, message: '请选择开票类型' }]"
              >
                <template #input>
                  <van-radio-group
                    v-model="$store.state.invoiceSub.invoiceInfo.type"
                  >
                    <van-radio
                      v-for="(type, type_index) in $store.state.invoiceSub
                        .needInvoiceCourses.invoice_type_list"
                      icon-size="15px"
                      :name="type.id"
                      :key="type_index"
                      v-show="
                        !type.admin_only ||
                          $store.state.invoiceSub.oldType === type.id
                      "
                      >{{ type.name }}</van-radio
                    >
                  </van-radio-group>
                </template>
              </van-field>
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.company_name"
                required
                label="单位名称"
                placeholder="开票抬头"
                :rules="[{ required: true, message: '请填写单位名称' }]"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.company_number"
                required
                label="纳税编号"
                placeholder="税号或统一社会信用代码"
                :rules="[{ required: true, message: '请填写纳税编号' }]"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.email"
                label="电子邮箱"
                :required="!isVatInvoice"
                placeholder="用于接收电子发票"
                :rules="emailRules"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.company_address"
                :required="isVatInvoice"
                label="单位地址"
                placeholder="公司注册信息地址"
                :rules="companyAddressRules"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.phone"
                :required="isVatInvoice"
                label="电话号码"
                placeholder="在税务系统预留的电话"
                :rules="phoneNumberRules"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.bank"
                :required="isVatInvoice"
                label="开户银行"
                placeholder="请仔细核对"
                :rules="bankRules"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.bank_number"
                :required="isVatInvoice"
                label="银行账户"
                placeholder="请仔细核对"
                :rules="bankNumberRules"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.receiver_address"
                label="发票邮寄地址"
                :required="isVatInvoice"
                placeholder="用于接收纸质发票"
                :rules="mailAddressRules"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.receiver"
                top
                label="收件人"
                :required="isVatInvoice"
                placeholder="发票收件人姓名"
                :rules="receiverRules"
              />
              <van-field
                v-model="$store.state.invoiceSub.invoiceInfo.receiver_phone"
                top
                label="收件人电话"
                :required="isVatInvoice"
                placeholder="收件人电话"
                :rules="receiverPhoneRules"
              />
            </van-cell-group>
            <van-divider
              :style="{
                color: '#c5c5c5',
                borderColor: '#c5c5c5',
                padding: '0 10px'
              }"
            />
          </div>

          <div style="text-align: center;">
            <van-button
              native-type="submit"
              size="normal"
              type="success"
              style="padding: 0 2em; margin: 10px auto;"
            >
              提交审核
            </van-button>
          </div>
        </van-form>
        <br />
        <br />
        <br />
      </div>
      <MainTabBar></MainTabBar>
    </div>
  </div>
</template>

<script>
import { Button, Step, Steps } from "vant";
import { Divider } from "vant";
import { NoticeBar, Empty } from "vant";
import { Icon } from "vant";
import { CellGroup } from "vant";
import { Field, Form } from "vant";
import { RadioGroup, Radio } from "vant";
import LoadingPage from "@/components/LoadingPage";
import MainTabBar from "@/components/MainTabBar";
import img_empty from "@/assets/imgs/empty.png";

export default {
  name: "Invoice",
  components: {
    "van-steps": Steps,
    "van-step": Step,
    "van-button": Button,
    "van-divider": Divider,
    "van-notice-bar": NoticeBar,
    "van-icon": Icon,
    "van-cell-group": CellGroup,
    "van-field": Field,
    "van-form": Form,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-empty": Empty,
    LoadingPage,
    MainTabBar
  },
  data() {
    return {
      active: 0,
      img_empty
    };
  },
  computed: {
    isVatInvoice() {
      let isVatInvoice = false;
      try {
        this.$store.state.invoiceSub.needInvoiceCourses.invoice_type_list.forEach(
          type => {
            if (type.id === this.$store.state.invoiceSub.invoiceInfo.type) {
              if (type.name.includes("增值")) {
                isVatInvoice = true;
              }
            }
          }
        );
      } catch (err) {
        isVatInvoice = false;
      }
      return isVatInvoice;
    },
    companyAddressRules() {
      return this.isVatInvoice
        ? [{ required: true, message: "请填写单位地址" }]
        : [];
    },
    phoneNumberRules() {
      return this.isVatInvoice
        ? [{ required: true, message: "请填写电话号码" }]
        : [];
    },
    bankRules() {
      return this.isVatInvoice
        ? [{ required: true, message: "请填写开户银行" }]
        : [];
    },
    bankNumberRules() {
      return this.isVatInvoice
        ? [{ required: true, message: "请填写银行账户" }]
        : [];
    },
    mailAddressRules() {
      return this.isVatInvoice
        ? [{ required: true, message: "请填写发票邮寄地址" }]
        : [];
    },
    receiverRules() {
      return this.isVatInvoice
        ? [{ required: true, message: "请填写收件人姓名" }]
        : [];
    },
    receiverPhoneRules() {
      return this.isVatInvoice
        ? [{ required: true, message: "请填写收件人电话" }]
        : [];
    },
    emailRules() {
      return !this.isVatInvoice
        ? [{ required: true, message: "电子邮件地址" }]
        : [];
    }
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("invoiceSub/toPutInvoiceInfo");
    },
    getStatus() {
      if (this.$store.state.invoiceSub.invoiceInfo.status === "VR") {
        return 1;
      }
      if (this.$store.state.invoiceSub.invoiceInfo.status === "DO") {
        return 2;
      }
      return 0;
    }
  },
  beforeMount() {
    this.$store.dispatch("users_tokenChecker");
    this.$store.commit("invoiceSub/initVoucherUp");
    this.$store.dispatch("invoiceSub/toGetNeedInvoiceCourses");
    this.$store.state.system.tabBarActive = "user";
  },
  updated() {
    if (this.$store.state.invoiceSub.needInvoiceCourses === null) {
      this.$store.dispatch("invoiceSub/toGetNeedInvoiceCourses");
    }
  }
};
</script>

<style scoped>
.message0 {
  color: #54564c;
  font-size: 14px;
  line-height: 20px;
  padding: 10px;
  margin: 0 auto 20px;
  background-color: #ebfff0;
  border-radius: 0.5rem;
}
.notice {
  margin-bottom: 10px;
}
</style>
